export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2026暑期档必看大片推荐：这10部电影不容错过',
    excerpt: '暑期档大片云集，从国产科幻到好莱坞动作片，我们为你精心挑选了10部最值得期待的电影，让你的夏日观影清单满满当当。',
    content: `<p>2026年的暑期档可谓是近年来最热闹的一届，国产片和进口片齐齐发力，类型丰富多样。今天我们就来盘点一下这个暑期档最值得期待的10部电影。</p>
<h3>国产科幻再创高峰</h3>
<p>继《流浪地球》系列之后，国产科幻电影持续发力。今年暑期档的科幻大片在视觉特效和故事深度上都达到了新的高度，以震撼的视觉效果和扎实的剧本赢得了观众的一致好评。</p>
<h3>动作大片燃爆夏日</h3>
<p>好莱坞动作系列新作如期而至，以酣畅淋漓的打斗场面和跌宕起伏的剧情，为观众带来极致的视听盛宴。大银幕上的每一帧都让人肾上腺素飙升。</p>
<h3>现实主义题材引发共鸣</h3>
<p>暑期档也少不了走心的现实主义题材作品。这些影片聚焦当下社会热点，以细腻的情感刻画和真实的叙事打动了无数观众，引发了广泛的社会讨论。</p>
<h3>动画电影全家欢</h3>
<p>暑期是亲子观影的黄金时期，多部制作精良的动画电影为家庭观众提供了丰富的选择。精美的画面和温暖的故事，让大人和孩子都能在影院中找到快乐。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20scene%20with%20warm%20ambient%20lighting%2C%20red%20velvet%20seats%2C%20large%20screen%20displaying%20vibrant%20colors%2C%20professional%20photography%2C%20atmospheric%20and%20inviting%20mood%2C%20high%20detail&width=1200&height=600&seq=article-01&orientation=landscape',
    category: '电影资讯',
    author: '影视小编',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['暑期档', '电影推荐', '国产电影', '好莱坞'],
  },
  {
    id: 2,
    title: '91影视看片app V5.2.0 版本更新：全新界面，更流畅的观影体验',
    excerpt: '91影视看片app最新版本V5.2.0正式发布，带来全新视觉设计、智能推荐算法升级、离线缓存优化等多项重磅更新。',
    content: `<p>经过开发团队数月的精心打磨，91影视看片app V5.2.0版本正式上线！本次更新聚焦用户体验提升，从界面设计到底层性能都进行了全面优化。</p>
<h3>全新视觉设计</h3>
<p>新版本采用了更加现代化的视觉设计语言，整体界面更加简洁清爽。重新设计的导航结构让用户能够更快地找到想看的内容，首页推荐也更加精准个性化。</p>
<h3>智能推荐升级</h3>
<p>全新的AI推荐引擎能够更准确地理解用户的观影偏好，推荐更符合口味的内容。无论是喜欢动作大片还是文艺小众，91影视都能为你找到心仪的影片。</p>
<h3>离线缓存优化</h3>
<p>离线缓存功能得到了全面改进，下载速度提升40%，同时优化了存储空间管理。用户可以更加灵活地管理缓存内容，智能清理过期缓存释放手机空间。</p>
<h3>播放体验提升</h3>
<p>播放器内核升级，支持更多视频格式，画质切换更加流畅。新增加的速度调节功能支持0.5倍到3倍速播放，满足不同场景的观看需求。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20movie%20streaming%20app%20interface%20with%20warm%20ambient%20lighting%2C%20clean%20minimalist%20design%2C%20on%20wooden%20desk%20with%20soft%20shadows%2C%20professional%20product%20photography&width=1200&height=600&seq=article-02&orientation=landscape',
    category: '应用更新',
    author: '产品小助手',
    date: '2026-07-25',
    readTime: '5分钟',
    tags: ['版本更新', '91影视', '新功能', '使用技巧'],
  },
  {
    id: 3,
    title: '如何用手机投屏到电视观看？三种最简单的方法',
    excerpt: '想把手机上的影视内容投屏到电视大屏观看？本文介绍三种最常用的投屏方法，让你轻松享受大屏观影的乐趣。',
    content: `<p>在手机上追剧虽然方便，但有时候还是觉得屏幕太小不够过瘾。今天就教大家三种最简单的投屏方法，让你轻松将手机内容投射到电视上观看。</p>
<h3>方法一：使用91影视内置投屏功能</h3>
<p>91影视看片app内置了投屏功能，只需确保手机和电视连接到同一个Wi-Fi网络，在播放页面点击投屏按钮，选择你的电视设备即可。这是最便捷的方式，推荐优先使用。</p>
<h3>方法二：使用手机系统自带投屏</h3>
<p>苹果手机用户可以使用AirPlay功能，安卓手机用户可以使用系统自带的屏幕镜像或无线投屏功能。在手机控制中心找到投屏选项，连接到支持投屏的智能电视即可。</p>
<h3>方法三：使用第三方投屏设备</h3>
<p>如果电视本身不支持投屏功能，可以购买Chromecast、小米盒子等投屏设备。将设备连接到电视的HDMI接口，按照设备说明完成设置后，即可实现投屏功能。</p>
<h3>投屏注意事项</h3>
<p>投屏时建议使用5GHz Wi-Fi频段以获得更稳定的传输效果。如果出现卡顿，可以尝试降低视频清晰度或靠近路由器使用。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Living%20room%20with%20large%20TV%20screen%20displaying%20movie%2C%20smartphone%20on%20coffee%20table%2C%20warm%20cozy%20lighting%2C%20modern%20home%20interior%2C%20comfortable%20atmosphere%2C%20professional%20photography&width=1200&height=600&seq=article-03&orientation=landscape',
    category: '使用教程',
    author: '技术小能手',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['投屏教程', '电视观看', '使用技巧', '大屏观影'],
  },
  {
    id: 4,
    title: '国产悬疑剧天花板！这5部高分作品值得反复观看',
    excerpt: '近年来国产悬疑剧佳作频出，从《隐秘的角落》到《狂飙》，国产悬疑剧的质量越来越高。本文为你盘点5部必看高分悬疑剧。',
    content: `<p>悬疑剧一直是观众最喜爱的类型之一。近年来，国产悬疑剧的质量突飞猛进，涌现出了一批口碑与收视双丰收的佳作。今天就来盘点5部不容错过的国产悬疑剧。</p>
<h3>《狂飙》——扫黑题材的巅峰之作</h3>
<p>张颂文、张译主演的《狂飙》以扫黑除恶为背景，讲述了警察安欣与黑恶势力长达二十年的斗争。剧中对人性的刻画入木三分，被称为近年来国产剧的标杆之作。</p>
<h3>《隐秘的角落》——年度最佳悬疑短剧</h3>
<p>改编自紫金陈的小说《坏小孩》，以三个孩子的视角展开一个关于秘密与谎言的故事。短短12集，却让人看完久久不能平静。</p>
<h3>《漫长的季节》——悬疑外壳下的人间悲欢</h3>
<p>范伟、秦昊主演，以一起碎尸案为引子，串联起东北小城二十年的变迁。剧集质感堪比电影，被誉为国产悬疑剧的新高度。</p>
<h3>《沉默的真相》——正义或许会迟到但不会缺席</h3>
<p>同样改编自紫金陈的小说，讲述了一位检察官为查明真相不惜一切代价的故事。白宇的表演令人动容，结局让人泪目。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20dark%20atmosphere%20with%20dramatic%20lighting%2C%20film%20noir%20style%20scene%2C%20shadowy%20urban%20alley%20at%20night%2C%20warm%20street%20lamp%20glow%2C%20mysterious%20mood%2C%20cinematic%20photography&width=1200&height=600&seq=article-04&orientation=landscape',
    category: '电视剧评',
    author: '追剧达人',
    date: '2026-07-18',
    readTime: '7分钟',
    tags: ['悬疑剧', '国产剧', '高分推荐', '追剧指南'],
  },
  {
    id: 5,
    title: '观影必备：如何选择最适合你的视频清晰度？',
    excerpt: '不同网络环境下应该如何选择视频清晰度？蓝光、超清、高清、标清各有什么区别？本文为你详解各种清晰度的差异和使用场景。',
    content: `<p>在91影视看片app中观看视频时，你可以根据网络状况和设备性能选择不同的清晰度。今天就来详细说说各种清晰度的区别和适用场景。</p>
<h3>各清晰度对比</h3>
<p><strong>4K超清（2160P）：</strong>分辨率3840×2160，画面极其细腻，适合在大屏电视上观看。需要较快的网络速度和较高的设备性能支持。</p>
<p><strong>蓝光1080P：</strong>分辨率1920×1080，目前最主流的高清格式。画面清晰，细节丰富，适合在手机、平板和电脑上观看。需要稳定的Wi-Fi或4G网络。</p>
<p><strong>超清720P：</strong>分辨率1280×720，画质良好，对网络要求适中。适合在4G网络或一般Wi-Fi环境下使用，是在流量和画质之间的良好平衡。</p>
<p><strong>高清480P：</strong>分辨率854×480，适合在网速较慢时使用。画质尚可，流量消耗少，是省流量的好选择。</p>
<h3>如何选择？</h3>
<p>使用Wi-Fi环境下建议选择1080P或更高清晰度。使用移动数据时建议选择720P或开启自动适配模式，让app根据实时网速智能调整。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20smartphone%20screen%20showing%20video%20quality%20settings%20interface%2C%20modern%20clean%20UI%20design%2C%20warm%20ambient%20lighting%2C%20minimalist%20tech%20photography%2C%20soft%20shadows&width=1200&height=600&seq=article-05&orientation=landscape',
    category: '使用教程',
    author: '技术小能手',
    date: '2026-07-15',
    readTime: '4分钟',
    tags: ['清晰度', '视频设置', '使用教程', '观影技巧'],
  },
  {
    id: 6,
    title: '从豆瓣评分看2026上半年最值得看的10部国产剧',
    excerpt: '2026年上半年国产剧市场百花齐放，我们根据豆瓣评分和观众口碑，整理了上半年评分最高的10部国产剧，看看你追过几部？',
    content: `<p>2026年已经过半，国产剧市场交出了一份亮眼的成绩单。我们结合豆瓣评分和观众口碑，整理了上半年最值得看的10部国产剧。</p>
<h3>古装题材持续发力</h3>
<p>古装剧依然是国产剧的重要类型。今年的古装剧在制作水准上有了明显提升，服化道更加精致，剧本也更有深度。多部作品凭借精良的制作和扎实的表演获得了观众和评论家的认可。</p>
<h3>现实主义题材佳作频出</h3>
<p>聚焦当下社会生活的现实主义题材作品越来越受到观众欢迎。这些剧集以真实感人的故事和细腻的情感刻画打动了观众，引发了对社会议题的广泛讨论。</p>
<h3>悬疑类型品质升级</h3>
<p>悬疑剧依然是观众的心头好。今年的悬疑剧在剧本打磨上更加用心，逻辑更加严密，反转更加出人意料，让观众追得欲罢不能。</p>
<h3>青春爱情剧的新探索</h3>
<p>青春爱情剧不再局限于甜宠套路，开始探索更多元的表达方式。温暖治愈、成长励志等元素的加入，让这一类型焕发出新的生命力。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20Chinese%20TV%20drama%20posters%20arranged%20artistically%20on%20a%20wall%2C%20warm%20gallery%20lighting%2C%20professional%20display%2C%20cinematic%20aesthetic%2C%20high%20detail%20photography&width=1200&height=600&seq=article-06&orientation=landscape',
    category: '电视剧评',
    author: '追剧达人',
    date: '2026-07-10',
    readTime: '9分钟',
    tags: ['国产剧', '豆瓣评分', '年度盘点', '追剧指南'],
  },
];

export const latestArticles = articles.slice(0, 3);